import React, { useState } from 'react'
import {
  FiAlertCircle,
  FiAlertOctagon,
  FiAlertTriangle,
  FiCheckCircle,
} from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { Divider, Label, ToastWrapper } from '../../components/Toasts'
import { ToastTypes } from './index'
import { PopoveredIcon2 } from '../../components/PopoveredIcon/PopoveredIcon'
import { useSelector } from 'react-redux'
import {
  getActiveLicense, isAllInOneLicenseValid,
  isLicenseValid,
  isNewPremiumLicenseValid,
} from '../../reducers/userAccount/selectors/license'
import UpgradePremiumBlockScreenModal from '../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { isUserNewPackage, isUserNewPremium } from '../../reducers/userAccount/selectors/userAccount'
import { LicenseType } from '../../models/License'

export default function Toast({
  children,
  type,
  withButton,
  buttonCb,
  buttonLabel,
  buttonIcon,
}: IToastProps) {
  const userActiveLicense = useSelector(getActiveLicense)
  const isUserLicenceValid = useSelector(isLicenseValid)

  const newPremium = useSelector(isNewPremiumLicenseValid)

  const isNewPremiumPriceGroup = useSelector(isUserNewPackage)
  const isAllInOnePriceGroup = useSelector(isUserNewPremium)
  const isAllInOneUser = useSelector(isAllInOneLicenseValid)
  const isAllInOneFreeUser = !isAllInOneUser && isAllInOnePriceGroup
  const isNewPremiumUser = newPremium && isNewPremiumPriceGroup
  const isLiteUser = isNewPremiumUser && userActiveLicense?.licenseType === LicenseType.LICENSE_PREMIUM_LITE
  const theme2 = useTheme()
  const isMobile = useMediaQuery(theme2.breakpoints.down('sm'))
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [popoverAnchor, setPopoverAnchor] = useState(null)

  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }
  switch (type) {
    case ToastTypes.Info:
      return (
        <ToastWrapper>
          <FiAlertCircle
            size={20}
            style={{ margin: '0px 20px', minHeight: '20px', minWidth: '20px' }}
          />
          <Divider />
          <Flex wrap={true}>
            {' '}
            <Label>{children}</Label>
            {withButton && (
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  minHeight: '30px',
                }}
                onClick={buttonCb}
              >
                <Label
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                  }}
                >
                  {buttonIcon} {buttonLabel}
                </Label>
              </div>
            )}
          </Flex>
        </ToastWrapper>
      )
    case ToastTypes.Success:
      return (
        <ToastWrapper>
          <FiCheckCircle
            size={20}
            style={{ margin: '0px 20px', minHeight: '20px', minWidth: '20px' }}
          />
          <Divider />
          <Flex wrap={true}>
            {' '}
            <Label>{children}</Label>
            {withButton && (
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  minHeight: '30px',
                }}
                onClick={buttonCb}
              >
                <Label
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                  }}
                >
                  {buttonIcon} {buttonLabel}
                </Label>
              </div>
            )}
          </Flex>
        </ToastWrapper>
      )
    case ToastTypes.Error:
      return (
        <ToastWrapper>
          <FiAlertOctagon
            size={20}
            style={{ margin: '0px 20px', minHeight: '20px', minWidth: '20px' }}
          />
          <Divider />
          <Flex wrap={true}>
            {' '}
            <Label>{children}</Label>
            {withButton && (
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  minHeight: '30px',
                }}
                onClick={((!isUserLicenceValid || (isLiteUser && !userActiveLicense?.has_invoices)) && !isAllInOneFreeUser) ? isMobile ? () => setIsModalOpened(true) : handlePopoverOpen : buttonCb}
              >
                <Label
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {((!isUserLicenceValid || (isLiteUser && !userActiveLicense?.has_invoices)) && !isAllInOneFreeUser) ? <div style={{marginRight: '8px'}}><PopoveredIcon2 variant={'white'}/></div> :  buttonIcon} <span>{buttonLabel}</span>
                </Label>
              </div>
            )}
          </Flex>
          <PopoveredIcon2
            style={{
              zIndex:9999
            }}
            withIcon={false}
            anchorEl={popoverAnchor}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          />
          {isMobile && <UpgradePremiumBlockScreenModal
            open={isModalOpened}
            close={() => setIsModalOpened(false)}
          />}
        </ToastWrapper>
      )
    case ToastTypes.Warning:
      return (
        <ToastWrapper style={{ maxWidth: '1200px' }}>
          <FiAlertTriangle
            size={20}
            style={{ margin: '0px 20px', minHeight: '20px', minWidth: '20px' }}
          />
          <Divider />
          <Flex wrap={true}>
            <Label>{children}</Label>
            {withButton && (
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  minHeight: '30px',
                }}
                onClick={(!isUserLicenceValid || isLiteUser) && !isAllInOneFreeUser ? isMobile ? () => setIsModalOpened(true) : handlePopoverOpen : buttonCb}
              >
                <Label
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {(!isUserLicenceValid || isLiteUser) && !isAllInOneFreeUser ? <div style={{marginRight: '8px'}}><PopoveredIcon2 variant={'white'}/></div> :  buttonIcon} <span>{buttonLabel}</span>
                </Label>
              </div>
            )}
          </Flex>
          <PopoveredIcon2
            style={{
              zIndex:9999
            }}
            withIcon={false}
            anchorEl={popoverAnchor}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          />
          {isMobile && <UpgradePremiumBlockScreenModal
            open={isModalOpened}
            close={() => setIsModalOpened(false)}
          />}
        </ToastWrapper>
      )
    default:
      break
  }
}

export interface IToastProps {
  type: ToastTypes
  children?: React.ReactNode
  withButton?: boolean
  buttonLabel?: string
  buttonCb?: () => void
  buttonIcon?: any
}
